import { FC } from "react";

// Services and Interfaces
import IconAction from "@/interfaces/components/icon_action";

// Components
import { Box } from "@mui/material";
import IconButton from "@/components/icon_button";


interface _ActionsProps {
    action1?: IconAction;
    action2?: IconAction;
    onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
    onMouseLeave?: (event: React.MouseEvent<HTMLElement>) => void;
}

const Actions: FC<_ActionsProps> = ({
    action1,
    action2,
    onMouseEnter,
    onMouseLeave
}) => {

    return (
        <Box
            className="Recipe__actions"
            position="absolute"
            top={0}
            right={0}
            display="flex"
            gap={1}
            p={1}
            zIndex={1}
            sx={{
                opacity: 0,
                transition: 'opacity 0.2s ease-in-out',
                pointerEvents: 'auto'
            }}>
            {action1 && <IconButton
                onMouseEnter={onMouseLeave}
                onMouseLeave={onMouseEnter}
                size="small"
                kind="ghost-image"
                icon={action1.icon}
                loading={action1.loading}
                onClick={(e) => {
                    e.stopPropagation();
                    action1.onClick?.();
                }}
                />}
            {action2 && <IconButton
                onMouseEnter={onMouseLeave}
                onMouseLeave={onMouseEnter}
                size="small"
                kind="ghost-image"
                icon={action2.icon}
                loading={action2.loading}
                onClick={(e) => {
                    e.stopPropagation();
                    action2.onClick?.();
                }}
                />}
        </Box>
    );
}

export default Actions;